import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import multiphotosAdapter from './multiphotos.adapter';

import photoModule from 'domains/photos';
import canvases from 'domains/canvases';
import cartProductEditor from 'domains/cart_product_editor';

import type {
  AddMultiPhotoPayload,
  AddMultiPhotoCropPayload,
  MultiPhotoEntity,
} from './multiphotos.types';

const multiphotos = createSlice({
  name: 'multiphotos',
  initialState: multiphotosAdapter.getInitialState(),
  reducers: {
    addMultiPhoto(state, { payload }: PayloadAction<AddMultiPhotoPayload>) {
      return multiphotosAdapter.addOne(state, { ...payload, nodeUid: '1' });
    },
    addMultipleMultiPhotos(state, { payload }: PayloadAction<number[]>) {
      const items: MultiPhotoEntity[] = payload.map((id) => ({
        id,
        photoId: id,
        nodeUid: '1',
        photoLoaded: false,
      }));

      return multiphotosAdapter.addMany(state, items);
    },
    addMultiPhotoCrop(state, { payload }: PayloadAction<AddMultiPhotoCropPayload>) {
      const { imageDimensions } = payload;
      return multiphotosAdapter.updateOne(state, {
        id: payload.id,
        changes: {
          imageHeight: imageDimensions.height,
          imageWidth: imageDimensions.width,
          photoLoaded: true,
        },
      });
    },
    deleteMultiPhoto(state, { payload }: PayloadAction<number>) {
      return multiphotosAdapter.removeOne(state, payload);
    },
    resetMultiPhotos() {
      return multiphotosAdapter.getInitialState();
    },
  },
  extraReducers(builder) {
    builder
      .addCase(photoModule.actions.removeManyPhotos.fulfilled, () => {
        return multiphotosAdapter.getInitialState();
      })
      .addCase(photoModule.actions.removePhoto.fulfilled, (state, { payload }) => {
        const update = multiphotosAdapter.removeOne(state, payload.id);
        return update;
      })
      .addCase(cartProductEditor.actions.pending, () => {
        return multiphotosAdapter.getInitialState();
      })
      .addCase(photoModule.actions.setActiveCollection, () => {
        return multiphotosAdapter.getInitialState();
      })
      .addCase(canvases.actions.resetToSingleCanvas, () => {
        return multiphotosAdapter.getInitialState();
      });
  },
});

export default multiphotos;
